import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "16",
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M0 0h20v2H0zM0 7h20v2H0zM0 14h20v2H0z" })
    ], -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-burger"}) } }